import { Injectable } from '@angular/core';
import { StateService } from './state.service';
import { StorageService } from './storage.service';
import { ViewGalleryHierarchyService } from './view-gallery-hierarchy.service';

@Injectable({
  providedIn: 'root',
})
export class GalleryPasswordService {
  passwords: { [galleryId: string]: string };

  constructor(
    private storage: StorageService,
    private viewGalleryHierarchyService: ViewGalleryHierarchyService,
    private state: StateService
  ) {
    this.passwords = this.storage.get('galleryPasswords') || {};
    this.state.removeAllGalleryPasswords = () => this.removeAllPasswords();
  }

  getPassword(galleryId: string): string {
    if (this.passwords[galleryId]) return this.passwords[galleryId];
    const gallery = this.viewGalleryHierarchyService.getParent(galleryId);
    if (gallery) return this.getPassword(gallery.galleryId);
  }

  setPassword(galleryId: string, password: string) {
    this.passwords[galleryId] = password;
    this.storage.set('galleryPasswords', this.passwords);
  }

  removePassword(galleryId: string) {
    delete this.passwords[galleryId];
    this.storage.set('galleryPasswords', this.passwords);
  }

  removeAllPasswords() {
    this.passwords = {};
    this.storage.set('galleryPasswords', this.passwords);
  }
}
